var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71179 8.12609C6.00058 8.16549 5.30073 8.45684 4.75742 9.00015L2.6361 11.1215C1.46452 12.293 1.46452 14.1925 2.6361 15.3641C3.80767 16.5357 5.70716 16.5357 6.87874 15.3641L9.00006 13.2428C9.54337 12.6995 9.83472 11.9996 9.87412 11.2884",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12609 6.71203C8.16549 6.00082 8.45684 5.30097 9.00015 4.75766L11.1215 2.63634C12.293 1.46477 14.1925 1.46477 15.3641 2.63634C16.5357 3.80791 16.5357 5.70741 15.3641 6.87898L13.2428 9.0003C12.6995 9.54361 11.9996 9.83496 11.2884 9.87436",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17152 11.8287L11.8284 6.17188",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.666369e09c0b660b24743f7fbac1cf0e.svg";
export { ForwardRef as ReactComponent };